<template>
  <b-card
    no-body
    class="card-developer-meetup card w-100"
  >
    <div class="bg-light-primary rounded-top text-center">
      <b-img
        :src="require('@/assets/images/illustration/email.svg')"
        alt="Meeting Pic"
        height="170"
      />
    </div>
    <b-card-body>
      <!-- metting header -->
      <div class="meetup-header d-flex align-items-center">
        <div class="my-auto">
          <b-card-title class="mb-25">
            <b-link @click="$emit('cardClick', item.id)">
              Competência {{ item.mesAno }}
            </b-link>
          </b-card-title>
        </div>
      </div>
      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            variant="light-primary"
            size="34"
          >
            <feather-icon
              icon="CalendarIcon"
              size="18"
            />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            {{ item.mesAno }}
          </h6>
        </b-media-body>
      </b-media>
      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            variant="light-primary"
            size="34"
          >
            <feather-icon
              icon="CheckIcon"
              size="18"
            />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <b-badge
            size="xs"
            :variant="getVariant(item)"
          >{{
            item.situacaoBalancete
          }}</b-badge>
        </b-media-body>
      </b-media>
      <b-media no-body>
        <b-media-aside class="mr-1">
          <b-avatar
            rounded
            variant="light-primary"
            size="34"
          >
            <feather-icon
              icon="UserIcon"
              size="18"
            />
          </b-avatar>
        </b-media-aside>
        <b-media-body>
          <h6 class="mb-0">
            {{ item.signatarios && item.signatarios.length }}
          </h6>
          <small>signatários</small>
        </b-media-body>
      </b-media>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BMedia, BMediaBody, BMediaAside, BAvatar,
} from 'bootstrap-vue'

export default {
  components: {
    BMedia,
    BMediaBody,
    BMediaAside,
    BAvatar,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getVariant(item) {
      if (item.situacaoBalancete === 'FECHADO') return 'secondary'
      if (item.situacaoBalancete === 'APROVADO') return 'primary'
      return 'tertiary'
    },
  },
}
</script>
